import { gql } from '@apollo/client';

import VendorConfigFragment from './vendor-config';

export default gql`
  fragment VendorConfigsFragment on VendorConfigs {
    sicom {
      ...VendorConfigFragment
    }
    sicomDelivery {
      ...VendorConfigFragment
    }
    ncr {
      ...VendorConfigFragment
    }
    ncrDelivery {
      ...VendorConfigFragment
    }
    toast {
      ...VendorConfigFragment
    }
    toastDelivery {
      ...VendorConfigFragment
    }
    carrols {
      ...VendorConfigFragment
    }
    carrolsDelivery {
      ...VendorConfigFragment
    }
    oheics {
      ...VendorConfigFragment
    }
    oheicsDelivery {
      ...VendorConfigFragment
    }
    qdi {
      ...VendorConfigFragment
    }
    qdiDelivery {
      ...VendorConfigFragment
    }
    qst {
      ...VendorConfigFragment
    }
    qstDelivery {
      ...VendorConfigFragment
    }
    rpos {
      ...VendorConfigFragment
    }
    rposDelivery {
      ...VendorConfigFragment
    }
    simplyDelivery {
      ...VendorConfigFragment
    }
    simplyDeliveryDelivery {
      ...VendorConfigFragment
    }
    tablet {
      ...VendorConfigFragment
    }
    tabletDelivery {
      ...VendorConfigFragment
    }
    productNumber {
      ...VendorConfigFragment
    }
  }

  ${VendorConfigFragment}
`;
